module.exports = __webpack_public_path__ + "0f5dfe6c23fb49a83d81d0f337c68e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_3.png
// module id = 125
// module chunks = 1